import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';

import {SiteLayout, User, Confirmation, SystemRoles} from '@varsity/services';

/*
  Generated class for the TicketsService provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NotificationsService {

    sitelayoutObservable = new ReplaySubject<SiteLayout>(1);
    sitelayout$ = this.sitelayoutObservable.asObservable();
    sitelayout?: SiteLayout;

    runningRequestsCountObservable = new ReplaySubject<number>(1);
    runningRequestsCount$ = this.runningRequestsCountObservable.asObservable();
    runningRequestsCount: number = 0;

    loggedInUserObservable = new ReplaySubject<User>(1);
    loggedInUser$ = this.loggedInUserObservable.asObservable();
    loggedInUser: User = null;

    confirmationChangedObservable = new ReplaySubject<Confirmation>(1);
    confirmationChanged$ = this.confirmationChangedObservable.asObservable();
    confirmation: Confirmation = null;

    filteredEventsAvailableObservable = new ReplaySubject<boolean>(1);
    filteredEventsAvailable$ = this.filteredEventsAvailableObservable.asObservable();

    availableNotificationsObservable = new ReplaySubject<number>(1);
    availableNotifications$ = this.availableNotificationsObservable.asObservable();
    notificationCounter: number = 0;

    windowMessageObservable = new Subject<any>();
    windowMessage$ = this.windowMessageObservable.asObservable();

    sectionLayoutObservable = new Subject<any>();
    sectionLayout$ = this.sectionLayoutObservable.asObservable();

    systemRolesObservable = new ReplaySubject<SystemRoles>();

    constructor(
        ngZone: NgZone
    ) {
        // receive messages on window
        (window as any).addEventListener('message', (event) => {
            ngZone.run(() => {
                this.windowMessageObservable.next(event);
            });
        });
    }

    notifySystemRolesAvailable(roles) {
        this.systemRolesObservable.next(roles);
    }

    notifySectionLayoutAvailable(section: any) {
        this.sectionLayoutObservable.next(section);
    }

    notifyFilteredEventsAvailable(flag: boolean) {
        this.filteredEventsAvailableObservable.next(flag);
    }

    notifyLayoutChanged(sitelayout?: SiteLayout) {
        this.sitelayout = sitelayout;
        this.sitelayoutObservable.next(sitelayout);
    }

    notifyUserLoginChanged(user: User) {
        this.loggedInUser = user;
        this.loggedInUserObservable.next(user);
    }

    notifyConfirmationChanged(confirmation: Confirmation) {
        this.confirmation = confirmation;
        this.confirmationChangedObservable.next(confirmation);
    }

    notifyRequestStarted() {
        this.runningRequestsCount++;
        this.runningRequestsCountObservable.next(this.runningRequestsCount);
    }

    notifyRequestCompleted() {
        this.runningRequestsCount--;
        this.runningRequestsCount = this.runningRequestsCount > -1 ? this.runningRequestsCount : 0;
        this.runningRequestsCountObservable.next(this.runningRequestsCount);
    }

    notifyAvailableNotificationsChanged(numberOfNotifications: number) {
        this.notificationCounter = numberOfNotifications;
        this.availableNotificationsObservable.next(numberOfNotifications);
    }

    //notifyPushNotificationReceived(receivedFlag: boolean) {
    //    this.pushNotificationReceivedFlag = receivedFlag;
    //    this.pushNotificationReceivedObservable.next(receivedFlag);
    //}
}



// WEBPACK FOOTER //
// ./src/services/notifications/notifications.service.ts